import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Icon from 'app/views/components/Icon'

// Utils
import analytics from 'app/views/utils/analytics'


const propTypes = {
  proxyStatus: PropTypes.oneOf([
    'loading',
    'reset',
    'init',
    'error',
    'listening',
    'disabled',
    'waiting',
  ]).isRequired,
  handleOnPopout: PropTypes.func.isRequired,
  intercept: PropTypes.bool.isRequired,
  onToggleIntercept: PropTypes.func.isRequired,
  onSandboxReset: PropTypes.func.isRequired,
}

class ProxyBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      resetButtonDisabled: true,
      statusLabels: {
        loading: {
          text: 'Loading...',
          type: 'warning',
        },
        reset: {
          text: 'Loading...',
          type: 'warning',
        },
        init: {
          text: 'Loading...',
          type: 'warning',
        },
        error: {
          text: 'Error',
          type: 'danger',
        },
        listening: {
          text: 'Listening',
          type: 'success',
        },
        disabled: {
          text: 'Disabled',
          type: 'secondary',
        },
        waiting: {
          text: 'Waiting for User...',
          type: 'warning',
        },
      },
      nativeStatusLabels: {
        loading: {
          text: 'Loading...',
          type: 'warning',
        },
        reset: {
          text: 'Loading...',
          type: 'warning',
        },
        init: {
          text: 'Loading...',
          type: 'warning',
        },
        error: {
          text: 'Error',
          type: 'danger',
        },
        listening: {
          text: 'Ready',
          type: 'success',
        },
        disabled: {
          text: 'Disabled',
          type: 'secondary',
        },
        waiting: {
          text: 'Waiting for User...',
          type: 'warning',
        },
      },
    }

    this.handleOnPopout = this.handleOnPopout.bind(this)
    this.handleOnReset = this.handleOnReset.bind(this)
    this.handleInterceptChange = this.handleInterceptChange.bind(this)
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      const proxyBar = document.getElementById('proxy-bar-container')
      if (proxyBar) {
        const topRelativeFromWindow = proxyBar.getBoundingClientRect().top
        if (topRelativeFromWindow < 20) {
          // window.location.reload(true)
        }
      }
      this.setState({
        resetButtonDisabled: false,
      })
    }, 5000)
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  handleOnPopout() {
    if (this.props.popoutMode) {
      analytics.track('click-standard-mode', {
        lessonId: this.props.match.params.id,
      })
    } else {
      analytics.track('click-popout-mode', {
        lessonId: this.props.match.params.id,
      })
    }

    this.props.handleOnPopout(!this.props.popoutMode)
  }

  handleOnReset() {
    analytics.track('click-sandbox-reset', {
      lessonId: this.props.match.params.id,
    })
    this.props.replSetCode(null, null)
    this.setState({ resetButtonDisabled: true })
    this.props.onSandboxReset(true)
    if (this.props.resetCallback) {
      this.props.resetCallback()
    }
    this.timeout = setTimeout(() => {
      this.setState({ resetButtonDisabled: false })
    }, 5000)
  }

  handleInterceptChange() {
    analytics.track('click-sandbox-intercept', {
      lessonId: this.props.match.params.id,
      value: !this.props.intercept,
    })

    this.props.onToggleIntercept()
  }

  render() {
    return (
      <div id="proxy-bar-container" className="uk-section uk-section-xsmall uk-margin-left">
        <div data-uk-grid>
          {(this.props.contentType !== 'native') ? (
            <div>
              <span className="uk-text-small uk-text-bold uk-margin-small-right">Proxy Status:</span>
              <a href="#" id="proxy-status">
                <span
                  data-test-id="proxy-status-indicator"
                  className={`uk-label uk-label-${this.state.statusLabels[this.props.proxyStatus].type}`}
                  data-uk-toggle="target: #modal-proxy-labels"
                >
                  {this.state.statusLabels[this.props.proxyStatus].text}
                </span>
              </a>
              <div id="modal-proxy-labels" data-uk-modal>
                <div className="uk-modal-dialog uk-modal-body">
                  <button className="uk-modal-close-default" type="button" data-uk-close />
                  <h2 >Proxy Status</h2>
                  <p>
                    This tells you if the proxy is ready to intercept request or not, or if the
                    proxy is waiting for your input. The colors below explain the possible states
                    for the proxy.
                  </p>
                  <div>
                    <table className="uk-table uk-table-small uk-table-divider">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>What it means</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="uk-label uk-label-success">Listening</span>
                          </td>
                          <td>
                            This means your proxy is listening for requests. Make a request in the
                            browser and open the proxy to see the request contents.
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="uk-label uk-label-secondary">Disabled</span>
                          </td>
                          <td>
                            Your proxy is not listening for requests. To turn it on, toggle the
                            switch to the right of the proxy status, labeled "Proxy Intercept".
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="uk-label uk-label-warning">Waiting For User</span>
                          </td>
                          <td>
                            The proxy has captured a request and is waiting for you to resubmit it
                            to the web server. Open the proxy, modify the request if you wish, and
                            click Resume to submit the request.
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="uk-label uk-label-warning">Loading...</span>
                          </td>
                          <td>
                            We are still creating your sandbox. This should only take a few seconds!
                            Let us know if it is taking too long, because it means something may be
                            wrong on our end.
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="uk-label uk-label-danger">Error</span>
                          </td>
                          <td>
                            Ooops... This was probably our bad...
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
              <div>
                <span className="uk-text-small uk-text-bold uk-margin-small-right">Sandbox Status:</span>
                <a href="#" id="proxy-status">
                  <span
                    className={`uk-label uk-label-${this.state.statusLabels[this.props.proxyStatus].type}`}
                    data-uk-toggle="target: #modal-proxy-labels"
                  >
                    {this.state.nativeStatusLabels[this.props.proxyStatus].text}
                  </span>
                </a>
                <div id="modal-proxy-labels" data-uk-modal>
                  <div className="uk-modal-dialog uk-modal-body">
                    <button className="uk-modal-close-default" type="button" data-uk-close />
                    <h2 >Sandbox Status</h2>
                    <p>
                      This tells you if the sandbox is ready for you or not. The colors below
                      explain the possible states for the sandbox.
                    </p>
                    <div>
                      <table className="uk-table uk-table-small uk-table-divider">
                        <thead>
                          <tr>
                            <th>Status</th>
                            <th>What it means</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span className="uk-label uk-label-success">Listening</span>
                            </td>
                            <td>
                              This means your proxy is listening for requests. Make a request in the
                              browser and open the proxy to see the request contents.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span className="uk-label uk-label-warning">Loading...</span>
                            </td>
                            <td>
                              We are still creating your sandbox. This should only take a few seconds!
                              Let us know if it is taking too long, because it means something may be
                              wrong on our end.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span className="uk-label uk-label-danger">Error</span>
                            </td>
                            <td>
                              Ooops... This was probably our bad...
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {(this.props.contentType !== 'native') && (
            <div className="uk-text-middle">
              <div>
                <label htmlFor="proxy-intercept" className="uk-text-small uk-text-bold">
                  Intercept Requests
                </label>
                &nbsp;
                <input
                  data-test-id="proxy-intercept-cb"
                  id="proxy-intercept"
                  className="uk-checkbox"
                  type="checkbox"
                  checked={this.props.intercept}
                  onChange={this.handleInterceptChange}
                />
              </div>
            </div>
          )}

          <div className="uk-width-expand uk-text-right uk-margin-right uk-flex uk-flex-middle uk-flex-right">

            {(this.props.url && this.props.tabCount < 2) && (
              <>
                <button
                  className="uk-button uk-button-muted uk-button-small uk-margin-small-right"
                  onClick={this.handleOnPopout}
                  id="popout-mode-btn"
                  style={{
                    textTransform: 'none',
                    fontSize: 13,
                    display: 'flex',
                    justiftContent: 'center',
                    alignItems: 'center',
                  }}
                  type="button"
                >

                  {(this.props.popoutMode) ? (
                    <>
                      <Icon
                        className="uk-margin-small-right"
                        name="window"
                        ratio={0.7}
                        style={{
                          WebkitTransform: 'rotate(180deg)',
                          MozTransform: 'rotate(180deg)',
                          msTransform: 'rotate(180deg)',
                          OTransform: 'rotate(180deg)',
                          transform: 'rotate(180deg)',
                        }}
                      />
                      Single Window Mode
                    </>
                  )
                    : (
                      <>
                        <Icon
                          ratio={0.8}
                          className="uk-margin-small-right"
                          name="bring-forward"
                          none
                        />
                        Popout Mode
                      </>
                    )}
                </button>
                <Icon
                  as="a"
                  href="https://help.hackedu.com/en/articles/3323850-popout-mode-vs-single-window-mode"
                  className="uk-margin-right uk-text-muted"
                  name="question"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </>
            )}

            <button
              className="uk-button uk-button-secondary uk-button-small uk-flex"
              data-test-id="reset-sandbox-btn"
              disabled={this.state.resetButtonDisabled}
              id="proxy-reset"
              onClick={this.handleOnReset}
              style={{
                textTransform: 'none',
                fontSize: 13,
                display: 'flex',
                justiftContent: 'center',
                alignItems: 'center',
              }}
              type="button"
            >
              <Icon className="uk-margin-small-right" name="restart" ratio={0.8} />
              <span>Reset Sandbox</span>
            </button>
          </div>

        </div>
      </div>
    )
  }
}

ProxyBar.propTypes = propTypes

export default withRouter(ProxyBar)
